class UserController {
  
  cloneDeep(user) {
    return {...user}
  }
  
  _setLoggedInUserToLocalStorage(user) {
    localStorage.setItem('LoggedInUser', JSON.stringify({data: user}));
  }
  
  _removeLoggedInUserFromLocalStorage() {
    localStorage.removeItem('LoggedInUser');
  }
  
  _getLoggedInUserFromLocalStorage() {
    return JSON.parse(localStorage.getItem('LoggedInUser')) ? JSON.parse(localStorage.getItem('LoggedInUser')).data : null;
  }
  
  _getLoggedInUserId() {
    let user = this._getLoggedInUserFromLocalStorage();
    if (user)
      return user.id;
  }
  
  _getLoggedInUserRole() {
    let user = this._getLoggedInUserFromLocalStorage();
    if (user) {
      if(user.role)
        return user.role;
    }
  }
  
  _getLoggedInUserRoleTitle() {
    let role = this._getLoggedInUserRole();
    if(role)
      return role.title;
  }
  
  _getLoggedInUserRoleId() {
    let role = this._getLoggedInUserRole();
    if(role)
      return role.id;
  }
  
  _setLoginErrorToLocalStorage() {
    localStorage.setItem('LoginError', JSON.stringify(true));
  }
  
  _removeLoginErrorFromLocalStorage() {
    localStorage.removeItem('LoginError');
  }
  
  _getLoginErrorFromLocalStorage() {
    return localStorage.getItem('LoginError') ? JSON.parse(localStorage.getItem('LoginError')) : null;
  }
}
export default new UserController();


// WEBPACK FOOTER //
// ./src/models/user/userController.js